import { Component, ViewEncapsulation } from '@angular/core';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class SpinnerComponent {

  public isLoading:boolean = false;

  constructor(public loader: LoaderService) {

  }

  ngDoCheck() {   
    this.isLoading = this.loader.getLoading();
  };

}